import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Shows the Instagram CTA only while the selected variant cannot be bought.
 *
 * The product form does not re-render this block when the variant changes: it
 * only morphs the button itself, so without this the CTA would keep whatever
 * state the server rendered. Mirrors how local-pickup.js reacts to the same
 * event.
 *
 * @extends {Component}
 */
class SoldOutCtaComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');

    /** @type {(event: VariantUpdateEvent) => void} */
    const variantUpdated = (event) => {
      // No resource means the chosen combination does not exist, which is also
      // a good moment to offer a conversation.
      const available = event.detail.resource ? event.detail.resource.available : false;

      this.toggleAttribute('hidden', Boolean(available));
    };

    closestSection?.addEventListener(ThemeEvents.variantUpdate, variantUpdated);

    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(ThemeEvents.variantUpdate, variantUpdated);
    };
  }
}

if (!customElements.get('sold-out-cta-component')) {
  customElements.define('sold-out-cta-component', SoldOutCtaComponent);
}
